import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import TravelTypes from '../components/TravelTypes';
import WhyChoose from '../components/WhyChoose';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';

const Home: React.FC = () => {
  return (
    <div className="page">
      <Hero />
      <Stats />
      <TravelTypes />
      <WhyChoose />
      <HowItWorks />
      <Testimonials />
    </div>
  );
};

export default Home; 